const ZoneSvg = ({ border, fill }: { border: string; fill: string }) => (
  <svg width="34" height="18" viewBox="0 0 34 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1" width="32" height="16" fill={fill} fillOpacity="0.2" stroke={border} strokeWidth="2" />
  </svg>
)

export default ZoneSvg
